import get from 'lodash/get';

const selectError = () => state => {
  const error = get(state, 'errors.error');
  if (!error) return null;
  return error;
};

export default selectError;
